module.exports = __webpack_public_path__ + "img/minus_circle.d9dce0e0.svg";